import { CALL_API } from '../middleware/api'

export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST'
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE'
export const PASSWORD_RESET_CONFIRM_REQUEST = 'PASSWORD_RESET_CONFIRM_REQUEST'
export const PASSWORD_RESET_CONFIRM_SUCCESS = 'PASSWORD_RESET_CONFIRM_SUCCESS'
export const PASSWORD_RESET_CONFIRM_FAILURE = 'PASSWORD_RESET_CONFIRM_FAILURE'

export const PASSWORD_RESET_CLIENT = 'compliance'

export function requestPasswordResetCode({ email }) {
  return {
    [CALL_API]: {
      endpoint: '/api/password-reset/',
      types: [PASSWORD_RESET_REQUEST, PASSWORD_RESET_SUCCESS, PASSWORD_RESET_FAILURE],
      method: 'POST',
      body: { email, client: PASSWORD_RESET_CLIENT },
    },
  }
}

export function confirmPasswordReset(body) {
  return {
    [CALL_API]: {
      endpoint: '/api/password-reset/confirm/',
      types: [PASSWORD_RESET_CONFIRM_REQUEST, PASSWORD_RESET_CONFIRM_SUCCESS, PASSWORD_RESET_CONFIRM_FAILURE],
      method: 'POST',
      body,
    },
  }
}
